import { Meta, Title } from '@angular/platform-browser';
import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

import { SEO, SEO_TAGS_TERMS_PAGE } from 'src/app/config';
@Component({
  templateUrl: './terms-page.component.html',
  styleUrls: ['./terms-page.component.scss']
})
export class TermsPageComponent implements OnInit {

  constructor(
    private location: Location,
    private title: Title,
    private meta: Meta,
    private translate: TranslateService
  ) {
    this.translate.get('shared-pages.terms-conditions.web-title').subscribe(() => {
      this.title.setTitle(this.translate.instant('shared-pages.terms-conditions.web-title') + ` | ${SEO.TITLE}`);
    });
    this.meta.addTags(SEO_TAGS_TERMS_PAGE)
  }

  ngOnInit(): void {
  }

  backRoute(): void {
    this.location.back()
  }
}
